export const SET_API_FAIL = { type: "SET_API_FAIL" }
export const CLEAR_API_FAIL = { type: "CLEAR_API_FAIL" }
